module.exports = __webpack_public_path__ + "img/9788990816115.c7eaaf18.jpg";